# 
div = document.createElement("div")

module.exports =
  toText: (content) ->
    div.innerHTML = content
    # only replace white space, not including &nbsp; it is used by our clients to keep non-breaking sentences
    div.textContent.replace new RegExp(' +', 'g'), " "

  toHTML: (content) ->
    div.textContent = content
    div.innerHTML
